import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base:
    process.env.NODE_ENV === "production"
      ? window.location.pathname.match(/^\/config\/vnext\/?/)
        ? "/config/vnext"
        : "/cms/cables-vnext"
      : "/",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/patch-cord",
      name: "patch-cord",
      component: () =>
        import(/* webpackChunkName: "patchCord" */ "./views/PatchCord.vue"),
    },
    {
      path: "/fanout",
      name: "fanout",
      // component: ()  => import(/* webpackChunkName: "fanout" */ './views/Fanout.vue')
      redirect: "/",
    },
    {
      path: "/breakout",
      name: "breakout",
      component: () =>
        import(/* webpackChunkName: "breakout" */ "./views/Breakout.vue"),
    },
    {
      path: "/trunk",
      name: "trunk",
      component: () =>
        import(/* webpackChunkName: "trunk" */ "./views/Trunk.vue"),
    },

    //## here code is comment out to disable cake configurator ##
    // {
    //   path: "/cake",
    //   name: "cake",
    //   component: () =>
    //     import(/* webpackChunkName: "cake" */ "./views/Cake.vue"),
    //   beforeEnter: (to, from, next) => {
    //     const validVoucher = "amphenolsachsenkabel";
    //     const voucherUsed = localStorage.getItem("cakeVoucherUsed");

    //     // If user already verified once, allow access
    //     if (voucherUsed === validVoucher) {
    //       next();
    //     } else {
    //       const enteredCode = prompt(
    //         "Please enter your voucher code to access Cake Configurator:"
    //       );

    //       if (enteredCode && enteredCode.trim() === validVoucher) {
    //         localStorage.setItem("cakeVoucherUsed", validVoucher);
    //         next(); // ✅ allow access
    //       } else {
    //         alert("Invalid voucher code.");
    //         next(false); // ❌ block navigation
    //       }
    //     }
    //   },
    // },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: () =>
        import(
          /* webpackChunkName: "privacyPolicy" */ "./components/privacyPolicy.vue"
        ),
    },
    // {
    //   path: '/edge-incompatible',
    //   name: 'edge-incompatible',
    //   component: ()  => import(/* webpackChunkName: "edgeIncompatible" */ './views/EdgeIncompatible.vue'),
    //   props: { disabled: true }
    // }
  ],
});

router.beforeEach((from, _, next) => {
  // global datacenter switch, can be used on each route lik ?dc=1
  if (from.query.dc && from.query.dc == 1)
    store.commit("setState", {
      stateKey: "getsDataCenterProducts",
      data: true,
    });

  // check if some values are set and would be reset on configurator type change
  if (Object.entries(store.state.filters.cables).length > 0) {
    let ok = confirm(
      "Die aktuelle Konfiguration geht mit dem Konfigratorenwechsel verloren"
    );

    if (!ok) return;
  }

  store.commit("clearAllFilters");
  store.commit("resetPartsList");
  store.state.customLabelSideA.line1 = "";
  store.state.customLabelSideA.line2 = "";
  store.state.customLabelSideB.line1 = "";
  store.state.customLabelSideB.line2 = "";

  store.commit("setState", { stateKey: "cables", data: [] });
  store.commit("setState", { stateKey: "plugs", data: [] });
  store.commit("setState", { stateKey: "cablesPlugsCombinations", data: [] });
  store.commit("setState", { stateKey: "bendProtections", data: [] });
  store.commit("setState", {
    stateKey: "plugsBendProtectionsCombinations",
    data: [],
  });
  store.commit("setState", { stateKey: "spreaders", data: [] });
  store.commit("setState", { stateKey: "whips", data: [] });
  store.commit("setState", { stateKey: "cablesWhipsCombinations", data: [] });
  store.commit("setState", { stateKey: "fixations", data: [] });
  store.commit("setState", { stateKey: "protections", data: [] });
  store.commit("setState", {
    stateKey: "cablesFixationsCombinations",
    data: [],
  });
  store.commit("setState", {
    stateKey: "cablesSpreadersCombinations",
    data: [],
  });
  store.commit("setState", {
    stateKey: "cablesProtectionsCombinations",
    data: [],
  });
  store.commit("setState", { stateKey: "labels", data: [] });

  next();
});

export default router;
